/// <amd-module name="Wit/Search/QueryProvider" />
import React = require("react");
import Resources = require("Wit/Search/Resources");
import { Services } from "VSS/Platform/Context";
import { ISearchInput } from "VSS/Platform/Search";
import { SearchHelpComponent, ISearchFilterGroup, ISearchFilter } from "VSS/Features/Search/SearchHelp";
import { VssIcon, VssIconType } from "VSSUI/VssIcon";
import { WorkitemSearchBaseProvider } from "Wit/Search/BaseProvider";

const defaultFilterGroup: ISearchFilterGroup = {
    caption: Resources.QueryHelpFilterGroupCaption,
    filters: [
        {
            text: Resources.AssignedToHint,
            getSuggestedText: (currentString: string, filterText: string) => { return 'a:"@Me"'; }
        },
        {
            text: Resources.CreatedByHint,
            getSuggestedText: (currentString: string, filterText: string) => { return 'c:"@Me"'; }
        },
        {
            text: Resources.StateHint,
            getSuggestedText: (currentString: string, filterText: string) => { return 's:""'; }
        },
        {
            text: Resources.WITHint,
            getSuggestedText: (currentString: string, filterText: string) => { return 't:""'; }
        }
    ]
}

class WorkitemQueryProvider extends WorkitemSearchBaseProvider {
    public help(searchInput: ISearchInput): JSX.Element {
        return (
            <SearchHelpComponent
                filterGroups={[defaultFilterGroup]}
                searchInput={searchInput}
                onRenderFilterText={onRenderFilterText}
            />
        );
    }
}

const onRenderFilterText = (filter: ISearchFilter, filterText: string): JSX.Element => {
    return <div>
        <VssIcon iconName="FilterSolid" iconType={VssIconType.fabric} className="workitem-query-filter-icon" />
        <span className="workitem-query-filter-text">{filter.text}</span>
    </div>;
}

Services.add("workitem-query-provider", { serviceFactory: WorkitemQueryProvider });
